import { Box, useTheme } from "@mui/material";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export const PieProgress = ({ percentage = 75, size = 25 }) => {
	const theme = useTheme();
	return (
		<Box sx={{ width: size, height: size, margin: "auto" }}>
			<CircularProgressbar
				value={percentage}
				// strokeWidth={50}
				text={`${percentage}%`}
				styles={buildStyles({
					pathColor: theme.palette.primary.main,
					trailColor: "rgba(0, 59, 109, 0.1)",
					strokeLinecap: "butt",
					textColor: theme.palette.primary.main,
				})}
			/>
		</Box>
	);
};
